export const can = (user, perm) => user?.role === 'master_admin' || (user?.permissions || []).includes(perm);

export const allowedBranches = (user, branches) =>
  (user?.branch_ids ? branches.filter((b) => user.branch_ids.includes(b.branch_id)) : branches);

const HOME = [['dashboard.view', '/dashboard'], ['stock_take.view', '/stock-take'], ['orders.view', '/orders'],
  ['stock_items.view', '/stock-items'], ['reports.view', '/reports']];

export const homePath = (user) => {
  if (user?.role === 'supplier') return '/supplier-dashboard';
  return (HOME.find(([p]) => can(user, p)) || [null, '/settings'])[1];
};
